import React, { useEffect, useState } from 'react';
import './ModernToast.css';

/**
 * Modern Toast Notification Component
 * Displays at bottom-right, auto-dismisses after 5 seconds
 * Types: success, error, warning, info
 */
function ModernToast({ 
  message, 
  type = 'info', 
  duration = 5000, 
  onDismiss,
  action = null // Optional: { label, onClick }
}) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!isVisible) {
      onDismiss?.();
      return;
    }

    const timer = setTimeout(() => {
      setIsVisible(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [isVisible, duration, onDismiss]);

  if (!isVisible) return null;

  return (
    <div className={`modern-toast toast-${type}`}>
      <div className="toast-content">
        <div className="toast-icon">
          {type === 'success' && <span>✓</span>}
          {type === 'error' && <span>✕</span>}
          {type === 'warning' && <span>⚠</span>}
          {type === 'info' && <span>ℹ</span>}
        </div>
        <div className="toast-message">
          {message}
        </div>
      </div>
      
      {action && (
        <button 
          className="toast-action"
          onClick={() => {
            action.onClick?.();
            setIsVisible(false);
          }}
        >
          {action.label}
        </button>
      )}
      
      <button 
        className="toast-close"
        onClick={() => setIsVisible(false)}
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );
}

export default ModernToast;
